import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import { stocktakeSideMsgBlocks } from '#/modules/imsMgmt/receipts/stocktake/data/stocktakeSideMsgConfig';

/** 盤點無 status／workflow；僅摘要欄位。 */
const StocktakeSideMsg = ({ displayData }) => (
  <SideMsg
    title="盤點單"
    titleValue="stocktakeNo"
    displayData={displayData}
    blocks={stocktakeSideMsgBlocks}
  />
);

StocktakeSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default StocktakeSideMsg;
